export default {"src":"/_next/static/media/HeadsetIcon.cd033ddc.svg","height":23,"width":23};